import useHttp from "../hooks/useHttp";
import { useEffect, useState, useContext } from "react";
import { PostContext } from "../context/post-context";
import { CardContent, Typography, Paper, Card } from "@mui/material";

const TodaysWord = () => {
  const postContext = useContext(PostContext);
  const { postLoading, postError, sendRequest: postRequest } = useHttp();
  const [lastPostId, setLastPostId] = useState(null);
  const [lastPostTimestamp, setLastPostTimestamp] = useState(null);
  const [postNum, setPostNum] = useState(1);
  const [apiCalled, setApiCalled] = useState(false);
  const [updating, setUpdating] = useState(false);

  const updatePost = (data) => {
    postContext.updatePosts(data);
    setPostNum(postNum + 1);
    if (data.length > 0) {
      setLastPostId(data[data.length - 1].id);
      setLastPostTimestamp(data[data.length - 1].timestamp);
    }
    setApiCalled(false);
    setUpdating(false);
  };

  const handleUpdatePosts = () => {
    if (!postLoading && !apiCalled && postContext.posts.length > 0) {
      const lastPost = postContext.posts[postContext.posts.length - 1];
      if (lastPost.id === lastPostId && lastPost.timestamp === lastPostTimestamp) {
        return;
      }
    }
    if(!updating){
      setUpdating(true);
    setApiCalled(true);
    postRequest(
      {
        url: `/api/users/posts/${postNum}`,
        params: { lastPostId, lastPostTimestamp },
      },
      updatePost
    );
  };
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 100
    ) {
      handleUpdatePosts();
    }
  };

  return (
    <Paper>
      {postContext.posts.map((post) => (
        <Card key={post.date} mt={2}>
          <CardContent>
            <Typography variant="body2" component="p">
              {post.date}
            </Typography>
            <Typography variant="h5" component="h2">
              {post.title}
            </Typography>
            <Typography variant="body2" component="p" sx={{ whiteSpace: "pre-line" }}>
              {post.content}
            </Typography>
          </CardContent>
          <Paper sx={{ backgroundColor: "#1976d2", color: "#FFF", p: 1, whiteSpace: "pre-line" }}>
            {post.questions.map((question, index) => (
              <Typography key={index} variant="body3" component="p" m={1}>
                {"Q" + (index + 1) + ". " + question}
              </Typography>
            ))}
          </Paper>
        </Card>
      ))}
      <div>
        {postLoading && <div>Loading...</div>}
        {!postLoading && postContext.posts.length === 0 && <div>No posts found.</div>}
        {!postLoading && postContext.posts.length > 0 && <div>End of content.</div>}
      </div>
    </Paper>
  );
};

export default TodaysWord;
